/* eslint-disable */

<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <div v-if="advanced_search">
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="cliente"
                                v-model="filter.client_id"
                                :items="clients"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                                @change="updateClient"
                            ></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="4" v-if="locations.length > 1" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="sede"
                                v-model="filter.location_id"
                                :items="locations"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="famiglia"
                                    multiple
                                    v-model="filter.search_family"
                                    :items="families"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2" />
                    <v-row no-gutters>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-text-field dense outlined
                                label="codice report"
                                v-model="filter.report_code"
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="operatore"
                                    v-model="filter.operator"
                                    :items="Object.values($store.state.users)"
                                    item-value="_id"
                                    item-text="name"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <div class="font-weight-bold">Data report</div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-column">
                            <div class="d-flex justify-left full-width my-2">
                                <v-btn class="" @click="periodChange(0, 0)">oggi</v-btn>
                                <v-btn class="ml-2" @click="periodChange(1, 1)">ieri</v-btn>
                                <v-btn class="ml-2" @click="periodChange(6, 0)">ultimi 7 giorni</v-btn>
                                <v-btn class="ml-2" @click="periodChange(29, 0)">ultimi 30 giorni</v-btn>
                            </div>
                            <div class="d-flex mt-1">
                                <span><CalendarField
                                    v-model="filter.from"
                                    label="da"
                                    clearable>
                                </CalendarField></span>
                                <span class="pl-2"><CalendarField
                                    v-model="filter.to"
                                    :minDate="filter.from"
                                    label="a"
                                    clearable>
                                </CalendarField></span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center">
                            <v-btn color="primary" class="text-center" @click="search"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-4"/>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center my-4">
                            <span class="d-flex flex-row">
                                <v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    hide-details
                                    @change="changeOrder"
                                ></v-autocomplete>
                                <v-autocomplete dense outlined
                                    class="px-2"
                                    label="operatore"
                                    v-model="filter.operator"
                                    :items="Object.values($store.state.users)"
                                    item-value="_id"
                                    item-text="name"
                                    @change="search"
                                    clearable
                                ></v-autocomplete>
                                <v-btn
                                    class="pl-2 pr-2"
                                    v-if="$store.state.config.enable_report_code_gen" 
                                    :disabled="!filter.operator || $store.state.offline"
                                    @click="editUser">aggiorna utente</v-btn>
                            </span>
                            <span class="pl-2" v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                    <v-tabs
                        class="mb-2"
                        grow
                        background-color="primary"
                        dark
                        v-model="op_idx">
                            <v-tab
                                v-for="(obj,idx) in Object.values(op_types)"
                                :key="idx">
                                {{obj.prefix}}
                            </v-tab>
                    </v-tabs>
                </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessun report trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="item in items" :key="item._id">
                            <td>
                            <ReportItem
                                class="full-width px-2"
                                :key="item._id"
                                :report_id="item._id"
                                :show_icon="true"
                                :show_action="true"
                                :show_instrument="true"
                                :show_client_short="true"
                                :disable_link="true"
                                :report_management="true"
                                @report_removed="updateSearch">
                            </ReportItem>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
        </BasicCard>
        <UserDialog
            max_width="80%"
            ref="user_dialog"
    />
    </div>
</template>

<script>
import {ListManagement} from "../../utils/listMixin"
import {report_type} from "../../utils/common.js"
import {filter_report_management} from "../../utils/statusManagement"
import BasicCard from "../../components/utils/Basic_card"
import UserDialog from "../admin/UserDialog"
    
import ReportItem from './ReportItem'
import {i_families} from "../../utils/common.js"
import { subDays, startOfDay, endOfDay} from 'date-fns'
import { searchDesign, orderByFields } from "../../utils/dbUtility.js"
// import _ from 'lodash'


export default {
    components:{BasicCard, ReportItem, UserDialog },
    mixins: [ListManagement],
    props: {
    },
    
    data(){
        return {
            disabledForNow: true,    // flag to disable buttons (check methods)
            sorting_fields: [
                {label: 'data report', value: ['value.report_date', 'value.code', 'value.owner_id'], order: ['desc', 'desc', 'desc']},
                {label: 'tecnico', value:['value.owner_id', 'value.report_date', 'value.code'], order: ['desc', 'desc', 'desc']},
                {label: 'codice report', value:['value.code', 'value.owner_id', 'value.report_date'], order: ['desc', 'desc', 'desc']},
            ],
            sort_fields: {},
            db: 'reports',
            filter: {
                client_id: null,
                location_id: null,
                department_id: null,
                report_code: null,
                search_family: [],
                operator: null,
                op_type: null,
                status: [],
                from: null,
                to: null
            },
            report_types: report_type,
            status: [],
            families: Object.keys(i_families),
            searching: false,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            clients: [],
            locations: [],
            op_types: report_type,
            report_ids: [],
            op_idx: 0,
            list_type: 'report'
        }
    },
    async mounted() {
        await this.getClients()
        let filter = this.restore_history_params()
        if (!filter) {
            this.filter.op_type = Object.values(this.op_types)[this.op_idx].id
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
        }
        this.updateSearch()
    },
    beforeDestroy() {
        this.object = []
    },
    methods: {
        async editUser(){
            let user = await this.axios.get("/mastercal/users/" + this.filter.operator).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione - riprovare. Se il problema persiste contattare l'amministratore"
                this.login_error = true
            });
            console.log(user.data)
            this.$refs.user_dialog.reset(user.data);
        },
        resetSearch(){
            this.filter  = {
                client_id: null,
                location_id: null,
                department_id: null,
                report_code: null,
                op_type: Object.values(this.op_types)[this.op_idx].id,
                operator: null,
                search_family: [],
                status: null,
                from: null,
                to: null
            }
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
         async getClients(){
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', 'client', false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.clients = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.clients = []
            }
        },
        async getDepartments() {
            if (this.filter.location_id) {
                let location = await this.$store.state.$pouch.get("registry", this.filter.location_id)
                this.departments = Object.values(location.departments)
            } else {
                this.filter.department_id = null
                this.departments = []
            }
        },
        async getLocations() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.filter.client_id], false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.locations = []
            }
        },
        async updateClient() {
          if (this.filter.client_id) {
              await this.getLocations()
            } else {
                this.filter.location_id = null
                this.filter.department_id = null
                this.locations = []
                this.departments = []
            }
        },
        async updateSearch() {
            this.searching = true
            var selectors = ['report']
            if (this.filter.client_id) {
                selectors.push(['client', this.filter.client_id])
            }
            if (this.filter.location_id) {
                selectors.push(['location', this.filter.location_id])
            }
            if (this.filter.report_code) {
                selectors.push(['report_code', this.filter.report_code])
            }
            if (this.filter.op_type) {
                selectors.push(['op_type', this.filter.op_type])
            }
            if (this.filter.operator) {
                selectors.push(['owner_id', this.filter.operator])
            }
            let res = await this.searchFromDesignNew('reports/searchByData', 'all_keys', selectors, false)
            res = res.filter((report) => {
                return filter_report_management[this.filter.op_type].includes(report.value.status)
            })
            if (this.filter.from || this.filter.to) {
                let from = 0
                let d_to = new Date()
                d_to.setFullYear(d_to.getFullYear() + 50)
                let to = d_to.getTime()
                if (this.filter.from) {
                    from = this.filter.from
                }
                if (this.filter.to) {
                    to = this.filter.to
                }
                let sd_from = startOfDay(from).getTime()
                let ed_to = endOfDay(to).getTime()
                let res_date = await this.searchFromDesignNew('reports/searchByData', 'range', [['op_date', sd_from], ['op_date', ed_to]], false)
                res = _.intersectionWith(res, res_date, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }

            if (this.filter.search_family.length > 0) {
                res = res.filter((report) => {
                    return this.filter.search_family.includes(report.value.family)
                })
            }
            this.objects = this.orderBy(res, this.sort_fields)

            // if (this.filter.search_family.length > 0) {
            //     let f_keys = [...Array(this.filter.search_family.length)].map((_, i) => ['family', this.filter.search_family[i]])
            //     let f_instrs = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'keys', f_keys, false)
            //     let i_ids = _.map(f_instrs, 'id');
            //     let i_ops = await this.searchFromDesignNew('reports/searchByData', 'keys', i_ids, false)
            //     let items = _.intersectionWith(res, i_ops, function(arrVal, othVal){
            //         return arrVal._id == othVal._id
            //     })
            //     this.objects = this.orderBy(items, this.sort_fields)
            // } else {
            //     this.objects = this.orderBy(res, this.sort_fields)
            // }
            this.searching = false
        },
        periodChange(f_days, t_days) {
            let now = (new Date()).getTime()
            this.filter.from = subDays(now, f_days).getTime()
            this.filter.to = subDays(now, t_days).getTime()
        }
    },
    watch: {
        'op_idx': {
            handler() {
                let op_type = Object.values(this.op_types)[this.op_idx].id
                this.filter.op_type = op_type
                this.updateSearch()
            }
        }
    }
}
</script>